import { render, staticRenderFns } from "./SelectGlossary.vue?vue&type=template&id=59ff26e3&"
import script from "./SelectGlossary.vue?vue&type=script&lang=js&"
export * from "./SelectGlossary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports